// material-ui
import { createTheme } from '@mui/material/styles';

// third-party
import { presetPalettes } from '@ant-design/colors';

// project import
import ThemeOption from './theme';
import header from './header';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode) => {
	const colors = presetPalettes;
	const isDarkMode = mode === 'dark';

	const greyPrimary = ['#ffffff', '#fafafa', '#f5f5f5', '#f0f0f0', '#d9d9d9', '#bfbfbf', '#8c8c8c', '#595959', '#262626', '#141414', '#000000'];
	const greyAscent = ['#fafafa', '#bfbfbf', '#434343', '#1f1f1f'];
	const greyConstant = ['#fafafb', '#e6ebf1'];

	colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

	const paletteColor = ThemeOption(colors);

	return createTheme({
		palette: {
			mode,
			...paletteColor,
			common: {
				// black: "#000",
				black: '#000D1A',
				white: '#ffffff',
				yellow: '#FBD062',
				green: '#4daa48',
				blue: '#0000ff',
			},
			text: {
				// primary: paletteColor.grey[700],
				primary: '#000D1A',
				secondary: '#526375',
				// disabled: paletteColor.grey[400],
			},
			lynTheme: {
				blue: '#214689',
				delete: '#B00020',
				success: '#00914F',
				arrow: '#161616',
				submit: '#03396c',
			},
			action: {
				disabled: paletteColor.grey[300],
			},
			divider: paletteColor.grey[200],
			border: '#e5e7eb', // '#bababa',
			background: {
				light: isDarkMode ? '#111827' : '#ffffff',
				paper: isDarkMode ? '#111827' : paletteColor.grey[0],
				// default: '#f5f5f7',
				default: isDarkMode ? '#0f172a' : '#f8fafc',
				// default: '#F8F9FA',
				secondary: isDarkMode ? '#0b1220' : '#e0e0e0',
				drawer: isDarkMode ? '#111827' : '#ffffff',
				main: isDarkMode ? '#0b1220' : '#f8fafc',
			},
			brandDark: {
				main: '#0e1628',
				contrastText: '#d1d5db',
			},

			// // for testing
			// header: header,
		},
	});
};

export default Palette;
